/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/
"use client";
import React from 'react';
import {PiArrowBendRightDownThin} from "react-icons/pi";
import AppAmbassadorPresentation from "./presentation/AppAmbassadorPresentation";
import AppAmbassadorHook from "./hook/AppAmbassadorHook";
import AppContact from "../contact/AppContact";
import AppAmbassadorRank from "./rank/AppAmbassadorRank";
import AppAmbassadorBenefits from "./benefits/AppAmbassadorBenefits";
import AppImageScroll from "@/components/random/AppImageScroll.tsx";
import AppStatic from "@/utils/AppStatic";
import Image from 'next/image';
import ambassadorSlider from '@/assets/images/slides/ambassador-slide-2.webp';
import SliderLogo from '@/assets/images/ambassador/weddify-ambassador-slider-logo.webp';
import AppFaq from "@/components/faq/AppFaq.tsx";

const AppAmbassadorPage = () => {

    const ambassadorFaq = [
        {
            title: AppStatic.appFaqAmbassadorFirstTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorFirstText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorSecondTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorSecondText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorThirdTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorThirdText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorFourthTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorFourthText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorFifthTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorFifthText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorSixthTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorSixthText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorSeventhTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorSeventhText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorEightTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorEightText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorNinthTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorNinthText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorTenthTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorTenthText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorEleventhTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorEleventhText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorTwelfthTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorTwelfthText.ro.translation,
        },
        {
            title: AppStatic.appFaqAmbassadorThirteenthTitle.ro.translation,
            content: AppStatic.appFaqAmbassadorThirteenthText.ro.translation,
        }
    ];


    return (
        <div className="bg-[#232323]">
            <div className="relative h-auto ambassador-slider">
                <div className="items-center w-full overflow-hidden h-full">
                    <AppImageScroll imageSource={ambassadorSlider}/>
                    <div
                        className="absolute overflow-hidden z-10 flex items-center justify-center top-0 bottom-0 right-0 left-0 m-auto">
                        <div className="grid grid-cols-1 lg:grid-cols-2 justify-center items-center">
                            <div className="pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-0 max-w-[738px]">
                                <h1 className="text-[#EBE6DE] text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold app-header-line-height">
                                    {AppStatic.mainAmbassadorHeading.ro.translation}
                                </h1>
                                <h3 className="text-xl mt-4 text-[#EBE6DE] lg:text-2xl">
                                    {AppStatic.mainAmbassadorSubHeadingPartOne.ro.translation}
                                    <span
                                        className="text-3xl font-bold">{AppStatic.mainAmbassadorSubHeadingPartTwo.ro.translation}</span>
                                    {AppStatic.mainAmbassadorSubHeadingPartThree.ro.translation}
                                </h3>
                                <div className="mt-1 text-[#AAAAAA] absolute bottom-4 text-lg flex gap-1 items-center">
                                    {AppStatic.mainAmbassadorHeadingContinue.ro.translation}
                                    <PiArrowBendRightDownThin className="text-4xl"/>
                                </div>
                            </div>
                            <div className="flex justify-center">
                                <Image className="hidden lg:flex w-[500px]" src={SliderLogo} alt={"Weddify by Diaphan"}
                                       priority={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="app-ambassador-hook" className="pt-10 md:pt-16 pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-20">
                <AppAmbassadorHook/>
            </div>
            <div id="app-ambassador-presentation" className="pb-10 pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-20">
                <AppAmbassadorPresentation/>
            </div>
            <div id="app-ambassador-rank" className="pb-10 pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-20">
                <AppAmbassadorRank/>
            </div>
            <div id="app-ambassador-benefits" className="mt-20 pb-10 pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-20">
                <AppAmbassadorBenefits/>
            </div>
            <div id="app-ambassador-presentation" className="pb-10 pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-20">
                <AppContact
                    minimalContact={true}
                    inputBgClass={"bg-[#EBE6DE]!"}
                    textMainColorClass={"text-[#EBE6DE]!"}
                    textSecondaryColorClass={"text-[#AAAAAA]!"}
                />
            </div>
            <div id="app-faq"
                 className="pt-0 pb-10 pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-20">
                <AppFaq faqData={ambassadorFaq}
                        faqContentColor={"text-[#EBE6DE]!"}
                        faqBackgroundColor={"bg-[#232323]!"}
                        faqTitleColor={"text-[#EBE6DE]!"}
                />
            </div>
        </div>
    );
}

export default AppAmbassadorPage;
